import { useTranslation } from 'react-i18next';

import { i18nNS } from '../../../../i18n';
import TimerIcon from '../../../../icons/TimerIcon';
import TimerWhiteIcon from '../../../../icons/TimerWhiteIcon';
import Tile from '../../../shared/Tile';
import TimerDrawer from '../TimerDrawer';
import useTimerTile from './vm';

const TimerTile = () => {
  const { t } = useTranslation([i18nNS.GLOSSARY]);

  const { isTimerDrawerOpen, handleCloseTimerDrawer, handleClick } = useTimerTile();

  return (
    <>
      <Tile
        icon={TimerWhiteIcon}
        hoverIcon={TimerIcon}
        title={t('timer', { ns: i18nNS.GLOSSARY })}
        color="warning"
        onClick={handleClick}
        isActive={isTimerDrawerOpen}
      />
      <TimerDrawer open={isTimerDrawerOpen} onClose={handleCloseTimerDrawer} />
    </>
  );
};

export default TimerTile;
